import {Stack, Title, Group, ActionIcon, Tooltip} from "@mantine/core";
import {Link, Outlet, useParams} from "react-router-dom";
import { supplierHooks } from "features/suppliers";
import {LoaderDefault, NoData} from "components/common";
import {DefaultPageWrapper} from "layouts";
import {ArrowLeft} from "tabler-icons-react";
import {RoutesResolver} from "routes";

export function Supplier() {
    const { supplierId } = useParams();
    const {isLoading, data: supplier } = supplierHooks.useGetById(parseInt(supplierId!), {

    });

    function renderContent() {
        if (isLoading) {
            return <LoaderDefault text="Loading Supplier"/>
        } else if (!supplier) {
            return <NoData title="No Supplier with specified ID found"/>
        } else {
            return <Outlet/>
        }
    }

    const routesResolver = new RoutesResolver();

    return (
        <Stack spacing={0}>
            <DefaultPageWrapper>
                <Group spacing="sm">
                    <Tooltip label="Back to Suppliers" withArrow>
                        <ActionIcon component={Link} size="sm" to={ routesResolver.suppliers }>
                            <ArrowLeft size={18}/>
                        </ActionIcon>
                    </Tooltip>
                    <Title>Insert Supplier Title Attribute</Title>
                </Group>
            </DefaultPageWrapper>
            <Stack>
                {renderContent()}
            </Stack>
        </Stack>
    )

}
